<template>
  <div @click="close" class="modal-backdrop">
    <div @click.stop class="modal-content" :class="{'no-padding':noPadding, 'g-16': !noHeading}"
         :style="{width: width+'px',height:height+'px', maxHeight: height+'px', minHeight}">
      <CrossIcon v-if="noHeading" class="mobile-close clickable" @click="close"/>
      <div class="header no-flex row full-width" v-if="!noHeading">
        <div class="title">
          <slot name="title"/>
        </div>
        <CrossIcon class="clickable" @click="close"/>
      </div>
      <div class="body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import CrossIcon from "~/components/icons/CrossIcon.vue";

const props = defineProps({
  width: {
    type: Number,
    default: 500
  },
  height: {
    type: Number,
    default: 500
  },
  minHeight: {
    type: Number,
    default: 0
  },
  noHeading: {
    type: Boolean,
    default: false
  },
  noPadding: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close']);

function close() {
  emit('close');
}

</script>

<style scoped lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999999999999;
  cursor: default;
}

.modal-content {
  background: $white;
  padding: 20px;
  max-width: 97%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  @include smd {
    width: 85% !important;
    height: auto !important;
    aspect-ratio: 1;
    max-height: 85% !important;
    padding: 10px;
  }
}

.mobile-close {
  display: none;
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 99999;
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  padding: 5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

  @include smd {
    display: block;
  }
}

.body {
  justify-content: flex-start;
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;

  @include smd {
    height: 100% !important;
  }
}

.header {
  align-items: flex-start;

  .title {
    font-size: 22px;
    font-weight: 600;
    color: $black;

    @include smd {
      max-width: 80%;
      font-size: 18px;
    }
  }

  svg {
    margin-left: auto;

    @include smd {
      height: 25px;
      width: 25px;
      margin-top: 1px;
    }
  }
}

.no-padding {
  padding: 0;

  &.modal-content {
    .mobile-close {
      background: rgba(255, 255, 255, 0.6); // Slightly more transparent when no padding
    }
  }
}
</style>
